import qrcode from 'qrcode-generator';

/**
 * A QR code as a matrix of dark modules (true = dark), for drawing as SVG on
 * screen and on the story card's canvas. Medium error correction: sturdy
 * enough for a phone screen at arm's length, small enough to stay scannable.
 */
export function qrMatrix(text: string): boolean[][] {
  const qr = qrcode(0, 'M');
  qr.addData(text, 'Byte');
  qr.make();
  const n = qr.getModuleCount();
  return Array.from({ length: n }, (_, r) => Array.from({ length: n }, (_, c) => qr.isDark(r, c)));
}

/** One SVG path for the dark modules, in module units (viewBox `0 0 n n`). */
export function qrPath(matrix: boolean[][]): string {
  let d = '';
  matrix.forEach((row, r) =>
    row.forEach((dark, c) => {
      if (dark) d += `M${c} ${r}h1v1h-1z`;
    }),
  );
  return d;
}

/** Draw the code onto a canvas, square at (x, y) with side `size`. */
export function drawQr(ctx: CanvasRenderingContext2D, matrix: boolean[][], x: number, y: number, size: number): void {
  const n = matrix.length;
  const cell = size / n;
  matrix.forEach((row, r) =>
    row.forEach((dark, c) => {
      // Overlap by a hair so anti-aliasing never draws seams between modules.
      if (dark) ctx.fillRect(x + c * cell, y + r * cell, cell + 0.5, cell + 0.5);
    }),
  );
}
